import { defineComponent as _defineComponent } from 'vue'
import { onMounted, onBeforeUnmount, computed, ref } from 'vue'
import { setLandbotInstance, getLandbotInstance } from '@/components/landbot/composables/useLandbot'
import useLocalStorage from '@/composables/useLocalStorage'
import { TrackerEvents, trackEvent } from '@/plugins/tracker'

interface AuthUser {
  firstName: string
  idProUser?: string
}

interface AuthData {
  user?: AuthUser
}

// DATA

export default /*#__PURE__*/_defineComponent({
  __name: 'LandbotLoader',
  setup(__props) {

const landbotOpenObserver = ref<MutationObserver | null>(null)

// COMPUTED
const user = computed<AuthUser | null>(() => {
  const { getItem } = useLocalStorage()
  const authData = getItem('authData') as AuthData | null
  return authData?.user || null
})

// METHODS
const initLandbot = () => {
  if (getLandbotInstance()) return // ya está cargado

  const script = document.createElement('script')
  script.type = 'module'
  script.async = true

  script.addEventListener('load', () => {
    if (!user.value) return
    const { firstName, idProUser } = user.value

    const customData = {
      name: firstName,
      entrada: idProUser || 'unknown',
      origin: process.env.VUE_APP_FRONT_URL || 'unknown'
    }

    // Landbot expone la clase en window.Landbot
    const instance = new window.Landbot.Livechat({
      configUrl: process.env.VUE_APP_LANDBOT_CONFIG_URL || '',
      customData
    })
    setLandbotInstance(instance)
  })
  script.src = process.env.VUE_APP_LANDBOT_SCRIPT_URL || ''
  document.head.appendChild(script)
}

const observeLandbotOpenState = () => {
  const landbotEl = document.querySelector('.LandbotLivechat')
  if (!landbotEl) {
    // Si el elemento aún no existe, reintenta en 5 segundos
    setTimeout(observeLandbotOpenState, 5000)
    return
  }

  landbotOpenObserver.value = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        const isOpen = landbotEl.classList.contains('is-open')
        if (isOpen) {
          handleBubbleClick()
        }
      }
    })
  })

  landbotOpenObserver.value.observe(landbotEl, { attributes: true })
}

const handleBubbleClick = () => {
  trackEvent(TrackerEvents.CLICK_LANDBOT_BUBBLE)
}

const addListeners = () => {
  window.addEventListener('mouseover', initLandbot, { once: true })
  window.addEventListener('touchstart', initLandbot, { once: true })
}

const removeListeners = () => {
  window.removeEventListener('mouseover', initLandbot)
  window.removeEventListener('touchstart', initLandbot)
}

// HOOKS
onMounted(() => {
  addListeners()
  observeLandbotOpenState()
})

onBeforeUnmount(() => {
  removeListeners()
  if (landbotOpenObserver.value) {
    landbotOpenObserver.value.disconnect()
  }
  const instance = getLandbotInstance()
  if (instance) {
    instance.destroy()
    setLandbotInstance(null)
  }
})

return { __sfc: true,landbotOpenObserver, user, initLandbot, observeLandbotOpenState, handleBubbleClick, addListeners, removeListeners }
}

})